import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomLink from 'components/Common/CustomLink/CustomLink';
import PlusCircleIcon from 'components/Common/Icons/PlusCircle';
import ModalDelivery from 'components/Modals/ModalDelivery/ModalDelivery';
import { useModal } from 'hooks/useModal';
import { getRoutesUri } from 'services/generic';
import { CustomerType } from 'types/Customer';

import styles from './ShippingNewAddress.module.scss';

export default function ShippingNewAddress({
  customer,
}: {
  customer: CustomerType;
}): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const { open, openModal, closeModal } = useModal();

  function onClick(e: React.MouseEvent<HTMLAnchorElement>) {
    if (customer.overseas === '1') {
      e.preventDefault();
      openModal();
    }
  }

  return (
    <div className={styles.wrapper}>
      <CustomLink
        to={getRoutesUri('customerAccountAddressSecondaryEdit') as string}
        state={{ redirectShippingPage: true }}
        className={styles.addLink}
        onClick={onClick}
      >
        <PlusCircleIcon />
        {t('SHIPPING_ADDRESS_ADD')}
      </CustomLink>
      <ModalDelivery isOpen={open} closeModal={closeModal} />
    </div>
  );
}
